import {
	type ConfirmMixturesSelection,
	usePostAdviceMixture,
	usePostConfirmMixtures,
	usePostFractionateFertilization,
	useUpdateAdviceMixture,
} from '@practium/features/api';
import type {
	FertilizationPlanAdvice,
	MaintenanceMixtureDraft,
	MaintenanceMixtureSettings,
} from '../types';

export interface MixtureActions {
	generate: (settings: MaintenanceMixtureSettings) => Promise<void>;
	create: (draft: MaintenanceMixtureDraft) => Promise<void>;
	update: (mixtureId: string, draft: MaintenanceMixtureDraft) => Promise<void>;
	confirm: (selection: ConfirmMixturesSelection) => Promise<void>;
	isPending: boolean;
}

export const useMixtureActions = (advice: FertilizationPlanAdvice): MixtureActions => {
	const planId = advice._id ?? '';
	const fractionate = usePostFractionateFertilization();
	const createMixture = usePostAdviceMixture();
	const updateMixture = useUpdateAdviceMixture();
	const confirmMixtures = usePostConfirmMixtures();

	return {
		generate: async (settings) => {
			await fractionate.mutateAsync({ planId, ...settings });
		},
		create: async (draft) => {
			await createMixture.mutateAsync({ planId, ...draft });
		},
		update: async (mixtureId, draft) => {
			await updateMixture.mutateAsync({ planId, mixtureId, ...draft });
		},
		confirm: async (selection) => {
			await confirmMixtures.mutateAsync({ planId, ...selection });
		},
		isPending:
			fractionate.isPending ||
			createMixture.isPending ||
			updateMixture.isPending ||
			confirmMixtures.isPending,
	};
};
